import React, { useEffect, useRef, useState } from "react";
import {
  Avatar,
  Badge,
  Button,
  Card,
  Col,
  Divider,
  Form,
  Input,
  InputNumber,
  Modal,
  Popover,
  Radio,
  Row,
  Select,
  Space,
  Spin,
  Tag,
  Typography,
} from "antd";
import {
  ChartColumnStacked,
  Check,
  CircleAlert,
  Edit,
  NotepadText,
  Plus,
  RotateCw,
  StickyNote,
  Trash2,
  UserRound,
} from "lucide-react";
import {
  getUsersPlanning,
  getUsersPlanningFinishTraining,
  getUsersPlanningToTraining,
  saveAnnotation,
  saveTraining,
} from "services/planning/planning-service";
import {
  notificationErroInternal,
  notificationInfo,
  notificationSucessMsg,
} from "util/api-utils";
import { translationsTypes } from "../planning/columns-table";
import { BRANCH_STORAGE, FONT } from "constants/index";
import DrawerApp from "components/drawer-app";
import PlanningExercises from "../planning/planning-drawer-exercises";
import FormNewUserPlanningExercise from "../planning/planning-drawer-new-exercise";
import ManagerialChart from "./managerial-drawer-chart";
import { ListEmptyState } from "views/util/emptyState";
import moment from "moment";
import FormNewUserReview from "../reviews/reviews-drawer-new-review";
import FormNewUserPlanning from "../planning/planning-drawer-new-planning";
import {
  closeTraining,
  getUsersBoot,
  getUsersBootToTraining,
  openTrainingBoot,
  saveAnnotationBoot,
  saveTrainingBoot,
} from "services/boot/boot-service";
import TimelineBoot from "./managerial-timeline-boot";
import ChangeBoot from "./managerial-change-boot";
import FormTrainningBoot from "../trainning/trainning-drawer-boot";
import { syncEvo, startSSE } from "services/evo/evo-service";
import useBreakpoint from "hooks/useBreakpoint";
import PageToolbar from "components/page-toolbar";
import { drawerWidth } from "util/responsive";
const { Meta } = Card;
const { confirm } = Modal;
const { TextArea } = Input;
const Managerial = () => {
  const { isMobile, isDesktop } = useBreakpoint();
  const useStackedLayout = !isDesktop;
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [openDetail, setOpenDetail] = useState(false);
  const [openChart, setOpenChart] = useState(false);
  const [lastUpdated, setLastUpdated] = useState(Date.now());
  const [userTrainer, setUserTrainer] = useState(null);
  const [openDetailItem, setOpenDetailItem] = useState(false);
  const [exercise, setExercise] = useState(null);
  const [formOpenUser] = Form.useForm();
  const [dataPlanning, setDataPlanning] = useState([]);
  const [trainingFinish, setTrainingFinish] = useState([]);
  const [openTrainingFinish, setOpenTrainingFinish] = useState(false);
  const [openChartFinish, setOpenChartFinish] = useState(false);
  const [openReview, setOpenReview] = useState({
    open: false,
    edit: false,
  });
  const [openPlaning, setOpenPlaning] = useState(false);
  const [formAnnotation] = Form.useForm();
  const [dataBoot, setDataBoot] = useState([]);
  const [dataInitialBoot, setDataInitialBoot] = useState([]);
  const [openProgress, setOpenProgress] = useState(false);
  const [userTrainerBoot, setUserTrainerBoot] = useState(null);
  const [formDoneBoot] = Form.useForm();
  const [openChangeTraining, setOpenChangeTraining] = useState(false);
  const [openDetailBoot, setOpenDetailBoot] = useState(false);
  const [syncLoading, setSyncLoading] = useState(false);

  const eventSourcesRef = useRef({});

  useEffect(() => {
    refreshData();
    return () => {
      Object.values(eventSourcesRef.current).forEach((es) => es.close());
    };
  }, []);

  const refreshData = () => {
    getAll();
  };
  const onCloseDetailBoot = () => {
    setOpenDetailBoot(false);
  };

  async function getAll() {
    try {
      setLoading(true);

      setLastUpdated(Date.now());
      await Promise.all([
        getData(),
        getDataPlanning(),
        getDataFinishTraning(),
        getDataBootTraining(),
        getDataBoot(),
      ]);
    } catch (error) {
      console.error("Erro ao buscar dados:", error);
    } finally {
      setLoading(false);
    }
  }

  const onCloseDetail = () => {
    setOpenDetail(false);
  };
  const onCloseChangeTraining = () => {
    setOpenChangeTraining(false);
    refreshData();
  };

  const onClosePlaning = () => {
    getDataFinishTraning();
    setOpenPlaning(false);
  };

  const onCloseFinishTraining = () => {
    setOpenTrainingFinish(false);
  };

  const onCloseChart = () => {
    refreshData();
    setOpenChart(false);
  };

  const onCloseChartFinish = () => {
    refreshData();

    setOpenChartFinish(false);
  };
  const onCloseReview = () => {
    getDataFinishTraning();
    setOpenReview({ open: false, edit: false });
  };
  const onCloseProgress = () => {
    setOpenProgress(false);
  };
  async function getDataPlanning() {
    let obj = {
      onlyHasPlan: true,
    };
    await getUsersPlanning(obj)
      .then((res) => {
        setDataPlanning(res);
      })
      .catch((err) => {
        notificationErroInternal(
          "Aconteceu um erro inesperado, por favor, tente mais tarde."
        );
      });
  }
  async function getDataFinishTraning() {
    await getUsersPlanningFinishTraining()
      .then((res) => {
        setTrainingFinish(res);
      })
      .catch((err) => {
        notificationErroInternal(
          "Aconteceu um erro inesperado, por favor, tente mais tarde."
        );
      });
  }

  async function getData() {
    await getUsersPlanningToTraining()
      .then((res) => {
        setData(res);
      })
      .catch((err) => {
        notificationErroInternal(
          "Aconteceu um erro inesperado, por favor, tente mais tarde."
        );
      });
  }

  async function updateEvo() {
    setSyncLoading(true);
    try {
      const { id } = JSON.parse(localStorage.getItem(BRANCH_STORAGE));
      const param = {
        branchId: id,
      };
      await syncEvo(param);
      startSSE(id, eventSourcesRef, finishedSync);
    } catch (error) {
      notificationErroInternal(
        "Aconteceu um erro inesperado, por favor, tente mais tarde."
      );
      setSyncLoading(false);
    }
  }
  async function finishedSync() {
    setSyncLoading(false);
    refreshData();
  }
  async function getDataBoot() {
    await getUsersBoot()
      .then((res) => {
        setDataInitialBoot(res);
      })
      .catch((err) => {
        notificationErroInternal(
          "Aconteceu um erro inesperado, por favor, tente mais tarde."
        );
      });
  }
  async function getDataBootTraining() {
    await getUsersBootToTraining()
      .then((res) => {
        setDataBoot(res);
      })
      .catch((err) => {
        notificationErroInternal(
          "Aconteceu um erro inesperado, por favor, tente mais tarde."
        );
      });
  }

  const DescriptionItem = ({ title }) => (
    <div
      className="site-description-item-profile-wrapper"
      style={{ fontFamily: FONT, fontSize: useStackedLayout ? 13 : 14 }}
    >
      <b>{title}</b>
    </div>
  );

  const CardField = ({ label, value }) => (
    <div className="card-field">
      <span className="card-field-label">{label}</span>
      <span className="card-field-value">{value}</span>
    </div>
  );

  function hasBackSquad(exercises) {
    return (
      exercises.filter((item) => item.planningType == "BACK_SQUAD").length > 0
    );
  }

  function getTranslationType(exercise) {
    var name =
      exercise.planningType == "ADDITIONAL_EXERCISE"
        ? exercise.additionalName
        : exercise.planningType == "NEW_EXERCISE"
        ? exercise.nameCvNew
        : translationsTypes[exercise.planningType];
    return name;
  }
  function getTranslationTypeBoot(exercise) {
    return translationsTypes[exercise] ?? exercise;
  }
  const Exercises = ({ exercises, forceStackedLayout = false }) => {
    const last = exercises[0]?.allTrainings.slice(-1);

    const load = exercises[0]?.trainings[0]?.load ?? last[0]?.load ?? 1;
    const stacked = useStackedLayout || forceStackedLayout;

    if (stacked) {
      return (
        <div className="exercise-list exercise-list-mobile custom-scroll">
          {exercises.map((exercise, index) => (
            <div
              key={index}
              className="responsive-card-item exercise-row-mobile"
            >
              <CardField
                label="Exercício"
                value={getTranslationType(exercise)}
              />
              <CardField
                label="Carga"
                value={exercise[`load${load}`] + "kg"}
              />
              <CardField
                label="VMP"
                value={
                  exercise[`vmp${load}`] != null
                    ? exercise[`vmp${load}`] + " - VMP"
                    : "—"
                }
              />
              <CardField
                label={exercise.planningType == "BARBELL_JUMP" ? "ALT(CM)" : "%1RM"}
                value={
                  exercise[`rm${load}`] != null
                    ? exercise.planningType == "BARBELL_JUMP"
                      ? exercise[`rm${load}`] + " - ALT(CM)"
                      : exercise[`rm${load}`] + " - %1RM"
                    : "—"
                }
              />
            </div>
          ))}
        </div>
      );
    }

    return (
      <div className="exercise-list exercise-list-desktop custom-scroll">
        <div className="exercise-table-desktop">
          <div className="exercise-table-header">
            <span>Exercício</span>
            <span>Carga</span>
            <span>VMP</span>
            <span>%1RM</span>
          </div>
          {exercises.map((exercise, index) => (
            <div key={index} className="exercise-table-row">
              <span className="exercise-table-cell exercise-name">
                {getTranslationType(exercise)}
              </span>
              <span className="exercise-table-cell">
                {exercise[`load${load}`]}kg
              </span>
              <span className="exercise-table-cell">
                {exercise[`vmp${load}`] != null
                  ? exercise[`vmp${load}`]
                  : "—"}
              </span>
              <span className="exercise-table-cell">
                {exercise[`rm${load}`] != null
                  ? exercise.planningType == "BARBELL_JUMP"
                    ? exercise[`rm${load}`] + " cm"
                    : exercise[`rm${load}`] + "%"
                  : "—"}
              </span>
            </div>
          ))}
        </div>
      </div>
    );
  };
  function getTagBoot(item) {
    const typeTrainingA = [
      "GOBLET_SQUAT",
      "HANG_CLEAN",
      "CONTINUOUS_JUMP",
      "SLDL_2_DUMBBELLS",
      "BENCH_BRIDGE_ONE_LEG",
    ];
    const typeTrainingB = [
      "SQUAT_FREE",
      "HANG_CLEAND_2T",
      "DEPTH_JUMP",
      "DEADLIFT",
      "BENCH_BRIDGE_TWO_LEGS",
    ];
    const typeTrainingC = [
      "FRONT_SQUAT",
      "SNATCH",
      "DROP_JUMP",
      "ROMANIAN_SURVEY",
    ];

    let typeTraining = "A";
    let color = "green";
    if (typeTrainingA.includes(item.typeExercise)) {
      typeTraining = "A";
      color = "green";
    }
    if (typeTrainingB.includes(item.typeExercise)) {
      typeTraining = "B";
      color = "geekblue";
    }
    if (typeTrainingC.includes(item.typeExercise)) {
      typeTraining = "C";
      color = "yellow";
    }
    return (
      <Tag color={color} key={typeTraining}>
        {typeTraining.toUpperCase()}
      </Tag>
    );
  }
  function getTagWeek(week) {
    let typeTraining = "A";
    let color = "green";

    if (week % 2 == 0) {
      typeTraining = "B";
      color = "geekblue";
    }

    return (
      <Tag color={color} key={typeTraining}>
        {typeTraining.toUpperCase()}
      </Tag>
    );
  }
  const ExercisesBoot = ({ training }) => {
    const exercises = [
      {
        step: training.step1,
        load: training.load1,
        exercise: training.exercise1,
        loadExecuted: training.loadExecuted1 ?? "X",
        typeExercise: training.typeExercise1,
        week: training.week1,
      },
      {
        step: training.step2,
        load: training.load2,
        exercise: training.exercise2,
        loadExecuted: training.loadExecuted2 ?? "X",
        typeExercise: training.typeExercise2,
        week: training.week2,
      },
      {
        step: training.step3,
        load: training.load3,
        exercise: training.exercise3,
        loadExecuted: training.loadExecuted3 ?? "X",
        typeExercise: training.typeExercise3,
        week: training.week3,
      },
      {
        step: training.step4,
        load: training.load4,
        exercise: training.exercise4,
        loadExecuted: training.loadExecuted4 ?? "X",
        typeExercise: training.typeExercise4,
        week: training.week4,
      },
    ];

    if (useStackedLayout) {
      return (
        <div className="exercise-list-boot exercise-list-mobile">
          {exercises.map((item, index) => (
            <div
              key={index}
              className="responsive-card-item exercise-row-mobile"
            >
              <CardField
                label="Exercício"
                value={getTranslationTypeBoot(item.exercise)}
              />
              <CardField
                label="Fase"
                value={
                  item.step == 4 ? (
                    <span>
                      {item.step} - {getTagBoot(item)}
                    </span>
                  ) : (
                    item.step
                  )
                }
              />
              <CardField
                label="Carga"
                value={
                  item.loadExecuted != "X"
                    ? item.loadExecuted + "Kg"
                    : item.loadExecuted
                }
              />
              <CardField
                label="Semanas"
                value={
                  <span>
                    {item.load} - {getTagWeek(item.week)}
                  </span>
                }
              />
            </div>
          ))}
        </div>
      );
    }

    return (
      <div className="exercise-list-boot exercise-list-desktop">
        <div className="boot-table-desktop">
          <div className="boot-table-header">
            <span>Exercício</span>
            <span>Fase</span>
            <span>Carga</span>
            <span>Semanas</span>
          </div>
          {exercises.map((item, index) => (
            <div key={index} className="boot-table-row">
              <span className="boot-table-cell boot-exercise-name">
                {getTranslationTypeBoot(item.exercise)}
              </span>
              <span className="boot-table-cell">
                {item.step == 4 ? (
                  <span>
                    {item.step} {getTagBoot(item)}
                  </span>
                ) : (
                  item.step
                )}
              </span>
              <span className="boot-table-cell">
                {item.loadExecuted != "X"
                  ? item.loadExecuted + "Kg"
                  : item.loadExecuted}
              </span>
              <span className="boot-table-cell">
                {item.load} {getTagWeek(item.week)}
              </span>
            </div>
          ))}
        </div>
      </div>
    );
  };
  function getWeek(planningExercise, name) {
    const week = planningExercise[0]?.trainings[0]?.load;
    const type = planningExercise[0]?.trainings[0]?.orderTraining;

    if (week) {
      const typeTraining = type % 2 === 0 ? "B" : "A";
      const color = type % 2 === 0 ? "geekblue" : "green";

      return (
        <div>
          {name} - Semana {week} -{" "}
          <Tag color={color} key={typeTraining}>
            {typeTraining.toUpperCase()}
          </Tag>
        </div>
      );
    }
    return name + " - Cíclo Finalizado";
  }
  function getWeekBoot(name) {
    return name;
  }
  const contentScoreDrop = (
    <div>
      <p>
        Queda ≤ 2% → Excelente – Atleta recuperado e pronto para treinar em alta
        intensidade
      </p>
      <p>
        Queda entre 2% e 5% → Bom – Atleta recuperado, mas pode precisar de
        pequenos ajustes no volume
      </p>
      <p>
        Queda entre 5% e 10% → Moderado – Indica sinais de fadiga; pode ser
        necessário reduzir o volume do treinamento
      </p>
      <p>
        Queda entre 10% e 15% → Ruim – Indica cansaço acumulado; sugere
        necessidade de um treino estabilizador ou ajuste no volume e na
        intensidade do treino
      </p>
      <p>
        Queda superior a 15% → Crítico – Indica risco de overtraining; é
        recomendado descanso completo ou um ajuste profundo na carga de
        treinamento
      </p>
    </div>
  );
  const contentScoreWellBeing = (
    <div>
      <p>
        4,5 a 5,0 → Excelente – Atleta recuperado e pronto para treinar em alta
        intensidade.
      </p>
      <p>
        3,5 a 4,4 → Bom – Atleta recuperado, mas pode precisar de ajustes
        menores na carga de treino.
      </p>
      <p>
        2,5 a 3,4 → Moderado – Indica sinais de fadiga; pode ser necessário
        reduzir a carga ou fazer um treino mais leve.
      </p>
      <p>
        1,5 a 2,4 → Ruim – Indica cansaço acumulado; sugere necessidade de
        descanso ativo ou ajuste significativo na carga.
      </p>
      <p>
        1,0 a 1,4 → Crítico – Indica risco de overtraining; é recomendado
        descanso completo ou um ajuste profundo no ciclo de treino.
      </p>
    </div>
  );
  function getScoreControl(value, showScore) {
    let color = "green";
    if (value < -10) {
      color = "red";
    }
    if (value <= -6 && value >= -10) {
      color = "yellow";
    }

    if (showScore) {
      return (
        <Popover content={contentScoreDrop} title="Valores de Queda">
          <div>
            <Tag color={color}>{value}</Tag>
          </div>
        </Popover>
      );
    } else {
      return (
        <div>
          <Tag color={color}>{value}</Tag>
        </div>
      );
    }
  }
  function getScoreControlWellBeing(value) {
    let color = "green";
    if (value < 1.5) {
      color = "red";
    }
    if (value < 2.5 && value >= 1.5) {
      color = "orange";
    }
    if (value < 3.5 && value >= 2.5) {
      color = "yellow";
    }
    if (value < 4.5 && value >= 3.5) {
      color = "blue";
    }
    return (
      <Popover content={contentScoreWellBeing} title="Interpretação Score">
        <div>
          <Tag color={color}>{value}</Tag>
        </div>
      </Popover>
    );
  }
  const ControlSection = ({ control }) => {
    if (!control) return null;

    if (useStackedLayout) {
      return (
        <div className="responsive-card-item control-section-mobile">
          <CardField label="CMJ PRÉ" value={control.cmjFirst} />
          <CardField
            label="Queda % (pré)"
            value={getScoreControl(control.cmjFirstDrop, true)}
          />
          <CardField
            label="Score"
            value={getScoreControlWellBeing(control.averageWellBeing)}
          />
          <CardField label="CMJ PÓS" value={control.cmjSecond} />
          <CardField
            label="Queda % (pós)"
            value={getScoreControl(control.cmjSecondDrop)}
          />
        </div>
      );
    }

    return (
      <div className="control-grid-desktop">
        <div className="control-cell">
          <span className="control-cell-label">CMJ PRÉ</span>
          <span className="control-cell-value">{control.cmjFirst}</span>
        </div>
        <div className="control-cell">
          <span className="control-cell-label">Queda %</span>
          <span className="control-cell-value">
            {getScoreControl(control.cmjFirstDrop, true)}
          </span>
        </div>
        <div className="control-cell">
          <span className="control-cell-label">Score</span>
          <span className="control-cell-value">
            {getScoreControlWellBeing(control.averageWellBeing)}
          </span>
        </div>
        <div className="control-cell">
          <span className="control-cell-label">CMJ PÓS</span>
          <span className="control-cell-value">{control.cmjSecond}</span>
        </div>
        <div className="control-cell">
          <span className="control-cell-label">Queda %</span>
          <span className="control-cell-value">
            {getScoreControl(control.cmjSecondDrop)}
          </span>
        </div>
      </div>
    );
  };
  const CardTrainings = ({ usersTrainings }) => {
    return usersTrainings.map((user) => {
      const [formUser] = Form.useForm();
      const planExercise =
        user?.planningTrainings?.filter(
          (p) => p.planningType == "BACK_SQUAD"
        ) ?? [];
      let isOpen = false;
      if (planExercise.length > 0) {
        const exercise = planExercise[0].trainings;
        if (exercise.length > 0) {
          isOpen = exercise[0].forceOpen;
          formUser.setFieldValue("vmp1", exercise[0].vmp1);
          formUser.setFieldValue("vmp2", exercise[0].vmp2);
          formUser.setFieldValue("vmp3", exercise[0].vmp3);
          formUser.setFieldValue("vmp4", exercise[0].vmp4);
        }
      }

      return (
        <Col key={user.id} xs={24} lg={12}>
          <Card
            className="training-card"
            style={{
              width: "100%",
              marginBottom: 16,
              display: "flex",
              flexDirection: "column",
            }}
            actions={getActionCard(user, formUser)}
          >
            <Meta
              className="training-card-meta"
              avatar={
                <Avatar
                  src={user?.img}
                  icon={
                    <UserRound size={useStackedLayout ? 48 : 56} />
                  }
                  size={useStackedLayout ? 48 : 56}
                />
              }
              title={<div>{getWeek(user.planningTrainings, user.name)}</div>}
              description={
                <div>
                  {useStackedLayout && (
                    <Row>
                      <Col span={9}>
                        <DescriptionItem title={"Exercícios"} />
                      </Col>
                    </Row>
                  )}
                  {user.planningTrainings.length == 0 && (
                    <Typography.Text italic color="warning">
                      Nenhum exercício planejado
                    </Typography.Text>
                  )}
                  {user.planningTrainings.length != 0 && (
                    <Exercises exercises={user.planningTrainings} />
                  )}
                  {hasBackSquad(user.planningTrainings) &&
                    (useStackedLayout ? (
                      <>
                        <Row style={{ marginTop: 10 }}>
                          <Col span={24}>
                            <DescriptionItem title={"VMP Agachamento"} />
                          </Col>
                        </Row>
                        <Form
                          form={formUser}
                          layout="vertical"
                          className="training-card-form-mobile"
                        >
                          <Row gutter={16}>
                            <Col xs={12} lg={6}>
                              <Form.Item name="vmp1">
                                <InputNumber
                                  decimalSeparator=","
                                  style={{ fontFamily: FONT, width: "100%" }}
                                  onBlur={() =>
                                    setVmp(formUser, user.planningId, isOpen)
                                  }
                                />
                              </Form.Item>
                            </Col>
                            <Col xs={12} lg={6}>
                              <Form.Item name="vmp2">
                                <InputNumber
                                  decimalSeparator=","
                                  style={{ fontFamily: FONT, width: "100%" }}
                                  onBlur={() =>
                                    setVmp(formUser, user.planningId, isOpen)
                                  }
                                />
                              </Form.Item>
                            </Col>
                            <Col xs={12} lg={6}>
                              <Form.Item name="vmp3">
                                <InputNumber
                                  decimalSeparator=","
                                  style={{ fontFamily: FONT, width: "100%" }}
                                  onBlur={() =>
                                    setVmp(formUser, user.planningId, isOpen)
                                  }
                                />
                              </Form.Item>
                            </Col>
                            <Col xs={12} lg={6}>
                              <Form.Item name="vmp4">
                                <InputNumber
                                  decimalSeparator=","
                                  style={{ fontFamily: FONT, width: "100%" }}
                                  onBlur={() =>
                                    setVmp(formUser, user.planningId, isOpen)
                                  }
                                />
                              </Form.Item>
                            </Col>
                          </Row>
                        </Form>
                      </>
                    ) : (
                      <div className="vmp-row-desktop">
                        <span className="vmp-label">VMP Agachamento</span>
                        <Form form={formUser} className="vmp-form">
                          <div className="vmp-inputs">
                            <Form.Item name="vmp1">
                              <InputNumber
                                decimalSeparator=","
                                style={{ fontFamily: FONT, width: "100%" }}
                                onBlur={() =>
                                  setVmp(formUser, user.planningId, isOpen)
                                }
                              />
                            </Form.Item>
                            <Form.Item name="vmp2">
                              <InputNumber
                                decimalSeparator=","
                                style={{ fontFamily: FONT, width: "100%" }}
                                onBlur={() =>
                                  setVmp(formUser, user.planningId, isOpen)
                                }
                              />
                            </Form.Item>
                            <Form.Item name="vmp3">
                              <InputNumber
                                decimalSeparator=","
                                style={{ fontFamily: FONT, width: "100%" }}
                                onBlur={() =>
                                  setVmp(formUser, user.planningId, isOpen)
                                }
                              />
                            </Form.Item>
                            <Form.Item name="vmp4">
                              <InputNumber
                                decimalSeparator=","
                                style={{ fontFamily: FONT, width: "100%" }}
                                onBlur={() =>
                                  setVmp(formUser, user.planningId, isOpen)
                                }
                              />
                            </Form.Item>
                          </div>
                        </Form>
                      </div>
                    ))}
                  <ControlSection control={user.control} />
                </div>
              }
            />
          </Card>
        </Col>
      );
    });
  };
  const FinishInfoFields = ({ user, lastTraining }) => (
    <div className="training-card-finish-info">
      <CardField
        label="Última Avaliação"
        value={moment(user.lastReview.reviewDate).format("DD/MM/YYYY")}
      />
      <CardField label="Último Treino" value={lastTraining || "—"} />
    </div>
  );
  const CardTrainingsFinish = ({ usersTrainings }) => {
    if (usersTrainings.length == 0) {
      return (
        <div style={{ textAlign: "center", width: "100%" }}>
          <ListEmptyState
            subTitle={"Não encontramos alunos com cíclo finalizado"}
          />
        </div>
      );
    }
    return (
      <div className="container-managerial">
        <Row gutter={[0, 0]}>
          {usersTrainings.map((user) => {
            const reviewDate = moment(user.lastReview.reviewDate);
            const planExercise = user.planningTrainings;
            let lastTraining = "";
            if (planExercise.length > 0) {
              const exercise = planExercise[0].allTrainings.slice(-1);
              if (exercise.length > 0) {
                lastTraining = moment(exercise[0].updatedAt);
              }
            }
            let isNewPlan = false;
            if (
              lastTraining != "" &&
              (lastTraining.isBefore(reviewDate) ||
                lastTraining?.format("DD/MM/YYYY") ==
                  reviewDate?.format("DD/MM/YYYY"))
            ) {
              isNewPlan = true;
            }
            lastTraining = lastTraining?.format("DD/MM/YYYY");
            const finishActions = getActionCardFinish(user);

            return (
              <Col key={user.id} xs={24}>
                <Card
                  className={`training-card training-card-finish${
                    finishActions.length <= 2
                      ? " training-card-finish--compact-actions"
                      : ""
                  }`}
                  style={{
                    width: "100%",
                    marginBottom: 16,
                    display: "flex",
                    flexDirection: "column",
                  }}
                  actions={finishActions.length > 0 ? finishActions : undefined}
                >
                  <Meta
                    className="training-card-meta"
                    avatar={
                      <Avatar
                        src={user?.img}
                        icon={
                          <UserRound size={useStackedLayout ? 48 : 56} />
                        }
                        size={useStackedLayout ? 48 : 56}
                      />
                    }
                    title={
                      <div>{getWeek(user.planningTrainings, user.name)}</div>
                    }
                    description={
                      <div>
                        <FinishInfoFields
                          user={user}
                          lastTraining={lastTraining}
                        />
                        <div className="training-card-section-title">
                          Exercícios
                        </div>
                        <Exercises
                          exercises={user.planningTrainings}
                          forceStackedLayout
                        />
                      </div>
                    }
                  />
                  <div className="training-card-finish-actions">
                    <Space wrap>
                      {isNewPlan && (
                        <Button
                          style={{
                            fontFamily: FONT,
                            background: "#1677ff",
                          }}
                          type="primary"
                          onClick={() => {
                            setUserTrainer(user);
                            setOpenPlaning(true);
                          }}
                          icon={
                            <Plus
                              size={18}
                              style={{
                                marginBottom: "-3px",
                                marginRight: "7px",
                              }}
                            />
                          }
                        >
                          Nova Planificação
                        </Button>
                      )}
                      <Button
                        style={{
                          fontFamily: FONT,
                          background: "#1677ff",
                        }}
                        type="primary"
                        onClick={() => {
                          setUserTrainer(user);
                          setOpenReview({
                            open: true,
                            edit: isNewPlan ? true : false,
                          });
                        }}
                        icon={
                          <Plus
                            size={18}
                            style={{
                              marginBottom: "-3px",
                              marginRight: "7px",
                            }}
                          />
                        }
                      >
                        {isNewPlan ? "Editar Avaliação" : "Nova Avaliação"}
                      </Button>
                    </Space>
                  </div>
                </Card>
              </Col>
            );
          })}
        </Row>
      </div>
    );
  };

  const CardTrainingsBoot = ({ usersTrainings }) => {
    return usersTrainings.map((user) => {
      return (
        <Col key={user.id} xs={24} lg={12}>
          <Card
            className="training-card"
            style={{
              width: "100%",
              marginBottom: 16,
              display: "flex",
              flexDirection: "column",
            }}
            actions={getActionCardBoot(user)}
          >
            <Meta
              className="training-card-meta"
              avatar={
                <Avatar
                  src={user?.img}
                  icon={
                    <UserRound size={useStackedLayout ? 48 : 56} />
                  }
                  size={useStackedLayout ? 48 : 56}
                />
              }
              title={<div>{getWeekBoot(user.name)}</div>}
              description={
                <div
                  className={`exercise-list-boot ${
                    useStackedLayout
                      ? "exercise-list-mobile"
                      : "exercise-list-desktop"
                  }`}
                >
                  <ExercisesBoot training={user.training} />
                  <ControlSection control={user.control} />
                </div>
              }
            />
          </Card>
        </Col>
      );
    });
  };
  const formatTime = (date) => {
    if (!date) return "Nunca atualizado";
    return new Intl.DateTimeFormat("pt-BR", {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    }).format(date);
  };
  const showDrawerDetail = () => {
    setOpenDetailItem(true);
  };
  function detail(row) {
    setExercise(row);
    showDrawerDetail();
  }
  const onCloseDetailItem = () => {
    setOpenDetailItem(false);
    setExercise(null);
  };
  const showDrawerTrainingFinish = () => {
    setOpenTrainingFinish(true);
  };

  function saveTrainingUser(user, formUser) {
    if (loading) {
      return;
    }
    if (user.planningTrainings[0].trainings.length == 0) {
      notificationInfo("Aluno com cíclo finalizado");
      return;
    }
    setLoading(true);

    const obj = {
      isDone: true,
      planningId: [user.planningId],
      vmp1: formUser.getFieldValue("vmp1"),
      vmp2: formUser.getFieldValue("vmp2"),
      vmp3: formUser.getFieldValue("vmp3"),
      vmp4: formUser.getFieldValue("vmp4"),
    };
    saveTraining(obj)
      .then(() => {
        notificationSucessMsg("Treino finalizado com sucesso");
        refreshData();
      })
      .catch((err) => {
        setLoading(false);
        notificationErroInternal(
          "Aconteceu um erro inesperado, por favor, tente mais tarde."
        );
      });
  }

  function getActionCard(user, form) {
    if (hasBackSquad(user.planningTrainings)) {
      return [
        <div
          onClick={() => {
            openAnotation(user);
          }}
        >
          <NotepadText />
        </div>,
        <div
          onClick={() => {
            setUserTrainer(user);
            setOpenChart(true);
          }}
        >
          <ChartColumnStacked />
        </div>,

        <div
          onClick={() => {
            setUserTrainer(user);
            setOpenDetail(true);
          }}
        >
          <Edit />
        </div>,
        <div onClick={() => setVmp(form, user.planningId, false, true)}>
          <Trash2 />
        </div>,
        <div onClick={() => saveTrainingUser(user, form)}>
          <Check />
        </div>,
      ];
    } else {
      return [
        <div
          onClick={() => {
            openAnotation(user);
          }}
        >
          <NotepadText />
        </div>,
        <div
          onClick={() => {
            setUserTrainer(user);
            setOpenDetail(true);
          }}
        >
          <Edit />
        </div>,
        <div onClick={() => setVmp(form, user.planningId, false, true)}>
          <Trash2 />
        </div>,
        <div onClick={() => saveTrainingUser(user, form)}>
          <Check />
        </div>,
      ];
    }
  }
  function getActionCardFinish(user) {
    const actions = [];

    if (hasBackSquad(user.planningTrainings)) {
      actions.push(
        <div
          key="chart"
          onClick={() => {
            setUserTrainer(user);
            setOpenChartFinish(true);
          }}
        >
          <ChartColumnStacked />
        </div>
      );
    }

    actions.push(
      <div
        key="edit"
        onClick={() => {
          setUserTrainer(user);
          setOpenDetail(true);
        }}
      >
        <Edit />
      </div>
    );

    return actions;
  }
  function getActionCardBoot(user) {
    const steps = [
      user.training.step1,
      user.training.step2,
      user.training.step3,
      user.training.step4,
    ];

    const isStep4Active = steps.some((step) => step === 4);
    const options = [
      <div
        onClick={() => {
          openAnotationBoot(user);
        }}
      >
        <NotepadText />
      </div>,
      <div
        onClick={() => {
          setOpenProgress(true);
          setUserTrainerBoot(user);
        }}
      >
        <ChartColumnStacked />
      </div>,
      isStep4Active && (
        <div
          onClick={() => {
            setOpenChangeTraining(true);
            setUserTrainerBoot(user);
          }}
        >
          <Edit />
        </div>
      ),
      <div onClick={() => closeTreiningBoot(user)}>
        <Trash2 />
      </div>,
      <div onClick={() => saveTrainingUserBoot(user)}>
        <Check />
      </div>,
    ];
    return options.filter((item) => item != false);
  }
  function setVmp(formUser, planningId, isOpen, forceClose) {
    setLoading(true);
    const obj = {
      isDone: false,
      planningId: [planningId],
      vmp1: formUser.getFieldValue("vmp1"),
      vmp2: formUser.getFieldValue("vmp2"),
      vmp3: formUser.getFieldValue("vmp3"),
      vmp4: formUser.getFieldValue("vmp4"),
      isOpen: isOpen,
      forceClose: forceClose,
    };
    saveTraining(obj)
      .then(() => {
        refreshData();
      })
      .catch((err) => {
        setLoading(false);
        notificationErroInternal(
          "Aconteceu um erro inesperado, por favor, tente mais tarde."
        );
      });
  }
  function updateList() {
    const idsToRemove = new Set(data.map((item) => item.id));
    const idsFinishTraining = new Set(trainingFinish.map((item) => item.id));
    const idsToRemoveBoot = new Set(dataBoot.map((item) => item.id));

    const result = dataPlanning.filter(
      (item) => !idsToRemove.has(item.id) && !idsFinishTraining.has(item.id)
    );

    const resultBoot = dataInitialBoot.filter(
      (item) => !idsToRemoveBoot.has(item.id)
    );
    result.push(...resultBoot);

    if (result.length == 0) {
      notificationInfo(
        "Todos os alunos disponíveis estão no painel ou com cíclos finalizados"
      );
      return;
    }

    const resultOrder = result.sort((a, b) => a.name.localeCompare(b.name));
    openTraing(resultOrder);
  }

  function openTraing(result) {
    confirm({
      title: (
        <div>
          <CircleAlert size={22} style={{ marginBottom: "-5px" }} />
          <span style={{ marginLeft: "10px", fontFamily: FONT }}>
            Qual Aluno ?
          </span>
          <div style={{ marginTop: "10px" }}>
            <Form form={formOpenUser} layout="vertical">
              <Row gutter={16}>
                <Col span={24}>
                  <Form.Item name="userOpen">
                    <Select
                      mode="multiple"
                      showSearch
                      optionFilterProp="children"
                    >
                      {result.map((item) => {
                        return <Option value={item.id}>{item.name}</Option>;
                      })}
                    </Select>
                  </Form.Item>
                  <Form.Item name="typeOpen">
                    <Radio.Group
                      options={[
                        { label: "Último Treino", value: "LAST" },
                        { label: "Novo Treino", value: "NEW" },
                      ]}
                      defaultValue={"NEW"}
                      optionType="button"
                      buttonStyle="solid"
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </div>
        </div>
      ),
      icon: null,
      okText: "Selecionar",
      cancelText: "Cancelar",
      onOk() {
        setLoading(true);

        const planIdFrom = formOpenUser.getFieldValue("userOpen");
        const usersPlan = [];
        const usersBoot = [];
        planIdFrom?.forEach((itemPlan) => {
          const isUserPlan = dataPlanning.filter((d) => d.id == itemPlan);
          const isUserBoot = dataInitialBoot.filter((d) => d.id == itemPlan);
          if (isUserPlan.length > 0) {
            usersPlan.push(isUserPlan[0].lastPlanId);
          }
          if (isUserBoot.length > 0) {
            usersBoot.push(itemPlan);
          }
        });

        if (usersPlan?.length == 0 && usersBoot.length == 0) {
          notificationInfo("É nescessário informar o aluno");
          setLoading(false);
          return;
        }

        if (usersPlan.length > 0) {
          const typeOpen = formOpenUser.getFieldValue("typeOpen");

          const obj = {
            isDone: false,
            isOpen: true,
            planningId: usersPlan,
            typeOpen: typeOpen ?? "NEW",
          };
          saveTraining(obj)
            .then(() => {
              formOpenUser.resetFields();
              refreshData();
            })
            .catch((err) => {
              formOpenUser.resetFields();
              setLoading(false);
              notificationErroInternal(
                "Aconteceu um erro inesperado, por favor, tente mais tarde."
              );
            });
        }

        if (usersBoot.length > 0) {
          const typeOpen = formOpenUser.getFieldValue("typeOpen");
          const obj = {
            users: usersBoot,
            typeOpen: typeOpen ?? "NEW",
          };
          openTrainingBoot(obj)
            .then(() => {
              formOpenUser.resetFields();
              refreshData();
            })
            .catch((err) => {
              formOpenUser.resetFields();
              setLoading(false);
              notificationErroInternal(
                "Aconteceu um erro inesperado, por favor, tente mais tarde."
              );
            });
          setLoading(false);
          formOpenUser.resetFields();
        }
      },
      onCancel() {
        formOpenUser.resetFields();
      },
    });
  }

  function openAnotationBoot(user) {
    const annotation = user.training.annotation ?? "";
    formAnnotation.setFieldValue("userAnnotation", annotation);
    confirm({
      title: (
        <div>
          <CircleAlert size={22} style={{ marginBottom: "-5px" }} />
          <span style={{ marginLeft: "10px", fontFamily: FONT }}>
            Anotações do Treino
          </span>
          <div style={{ marginTop: "10px" }}>
            <Form form={formAnnotation} layout="vertical">
              <Row gutter={16}>
                <Col span={24}>
                  <Form.Item name="userAnnotation">
                    <TextArea rows={8} />
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </div>
        </div>
      ),
      icon: null,
      okText: "Salvar",
      cancelText: "Cancelar",
      onOk() {
        const obj = {
          trainingId: user.training.id,
          annotation: formAnnotation.getFieldValue("userAnnotation"),
        };
        saveAnnotationBoot(obj)
          .then(() => {
            refreshData();
          })
          .catch((err) => {
            setLoading(false);
            formAnnotation.resetFields();
            notificationErroInternal(
              "Aconteceu um erro inesperado, por favor, tente mais tarde."
            );
          });
      },
      onCancel() {
        formAnnotation.resetFields();
      },
    });
  }
  function openAnotation(user) {
    const planExercise = user.planningTrainings.filter(
      (p) => p.planningType == "BACK_SQUAD"
    );
    let annotation = "";
    if (planExercise.length > 0) {
      const exercise = planExercise[0].trainings;
      if (exercise.length > 0) {
        annotation = exercise[0].annotation;
      }
    }

    formAnnotation.setFieldValue("userAnnotation", annotation);
    confirm({
      title: (
        <div>
          <CircleAlert size={22} style={{ marginBottom: "-5px" }} />
          <span style={{ marginLeft: "10px", fontFamily: FONT }}>
            Anotações do Treino
          </span>
          <div style={{ marginTop: "10px" }}>
            <Form form={formAnnotation} layout="vertical">
              <Row gutter={16}>
                <Col span={24}>
                  <Form.Item name="userAnnotation">
                    <TextArea rows={8} />
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </div>
        </div>
      ),
      icon: null,
      okText: "Salvar",
      cancelText: "Cancelar",
      onOk() {
        const obj = {
          planningId: user.planningId,
          annotation: formAnnotation.getFieldValue("userAnnotation"),
        };
        saveAnnotation(obj)
          .then(() => {
            refreshData();
          })
          .catch((err) => {
            setLoading(false);
            formAnnotation.resetFields();
            notificationErroInternal(
              "Aconteceu um erro inesperado, por favor, tente mais tarde."
            );
          });
      },
      onCancel() {
        formAnnotation.resetFields();
      },
    });
  }
  function saveTrainingUserBoot(user) {
    formDoneBoot.setFieldValue("loadExecuted1", user.training.loadExecuted1);
    formDoneBoot.setFieldValue("loadExecuted2", user.training.loadExecuted2);
    formDoneBoot.setFieldValue("loadExecuted3", user.training.loadExecuted3);
    formDoneBoot.setFieldValue("loadExecuted4", user.training.loadExecuted4);
    const allStep = [
      user.training.step1,
      user.training.step2,
      user.training.step3,
      user.training.step4,
    ].filter((item) => item < 4);
    confirm({
      title: (
        <div>
          <CircleAlert size={22} style={{ marginBottom: "-5px" }} />
          <span style={{ marginLeft: "10px", fontFamily: FONT }}>
            Finalização do Treino
          </span>
          <div style={{ marginTop: "10px" }}>
            <Form form={formDoneBoot} layout="vertical">
              <Row gutter={16}>
                <Col span={24}>
                  {allStep.length > 0 && (
                    <Form.Item
                      name="nextStep"
                      label={
                        <span style={{ fontFamily: FONT }}>
                          Progredir Treino
                        </span>
                      }
                    >
                      <Select
                        mode="multiple"
                        showSearch
                        optionFilterProp="children"
                      >
                        {user.training.step1 < 4 && (
                          <Option value={user.training.exercise1}>
                            {getTranslationTypeBoot(
                              user.training.typeExercise1
                            )}
                          </Option>
                        )}
                        {user.training.step2 < 4 && (
                          <Option value={user.training.exercise2}>
                            {getTranslationTypeBoot(
                              user.training.typeExercise2
                            )}
                          </Option>
                        )}
                        {user.training.step3 < 4 && (
                          <Option value={user.training.exercise3}>
                            {getTranslationTypeBoot(
                              user.training.typeExercise3
                            )}
                          </Option>
                        )}
                        {user.training.step3 < 4 && (
                          <Option value={user.training.exercise4}>
                            {getTranslationTypeBoot(
                              user.training.typeExercise4
                            )}
                          </Option>
                        )}
                      </Select>
                    </Form.Item>
                  )}
                  {user.training.step1 == 4 && (
                    <Form.Item
                      name="loadExecuted1"
                      label={
                        <span style={{ fontFamily: FONT }}>
                          {getTranslationTypeBoot(user.training.typeExercise1)}
                        </span>
                      }
                    >
                      <InputNumber
                        decimalSeparator=","
                        style={{ fontFamily: FONT, width: "100%" }}
                      />
                    </Form.Item>
                  )}
                  {user.training.step2 == 4 && (
                    <Form.Item
                      name="loadExecuted2"
                      label={
                        <span style={{ fontFamily: FONT }}>
                          {getTranslationTypeBoot(user.training.typeExercise2)}
                        </span>
                      }
                    >
                      <InputNumber
                        decimalSeparator=","
                        style={{ fontFamily: FONT, width: "100%" }}
                      />
                    </Form.Item>
                  )}
                  {user.training.step3 == 4 && (
                    <Form.Item
                      name="loadExecuted3"
                      label={
                        <span style={{ fontFamily: FONT }}>
                          {getTranslationTypeBoot(user.training.typeExercise3)}
                        </span>
                      }
                    >
                      <InputNumber
                        decimalSeparator=","
                        style={{ fontFamily: FONT, width: "100%" }}
                      />
                    </Form.Item>
                  )}
                  {user.training.step4 == 4 && (
                    <Form.Item
                      name="loadExecuted4"
                      label={
                        <span style={{ fontFamily: FONT }}>
                          {getTranslationTypeBoot(user.training.typeExercise4)}
                        </span>
                      }
                    >
                      <InputNumber
                        decimalSeparator=","
                        style={{ fontFamily: FONT, width: "100%" }}
                      />
                    </Form.Item>
                  )}
                  <Form.Item
                    name="doneBoot"
                    label={
                      <span style={{ fontFamily: FONT }}>
                        Finalizar Iniciação
                      </span>
                    }
                  >
                    <Radio.Group
                      options={[
                        { label: "Manter", value: false },
                        { label: "Avançar", value: true },
                      ]}
                      defaultValue={false}
                      optionType="button"
                      buttonStyle="solid"
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </div>
        </div>
      ),
      icon: null,
      okText: "Salvar",
      cancelText: "Cancelar",
      onOk() {
        const obj = {
          trainingId: user.training.id,
          loadExecuted1: formDoneBoot.getFieldValue("loadExecuted1"),
          loadExecuted2: formDoneBoot.getFieldValue("loadExecuted2"),
          loadExecuted3: formDoneBoot.getFieldValue("loadExecuted3"),
          loadExecuted4: formDoneBoot.getFieldValue("loadExecuted4"),
          doneBoot: formDoneBoot.getFieldValue("doneBoot") ?? false,
          nextStep: formDoneBoot.getFieldValue("nextStep") ?? [],
        };

        saveTrainingBoot(obj)
          .then(() => {
            formDoneBoot.resetFields();

            refreshData();
          })
          .catch((err) => {
            setLoading(false);
            formDoneBoot.resetFields();
            notificationErroInternal(
              "Aconteceu um erro inesperado, por favor, tente mais tarde."
            );
          });
      },
      onCancel() {
        formDoneBoot.resetFields();
      },
    });
  }
  function closeTreiningBoot(user) {
    setLoading(true);

    closeTraining(user.training.id)
      .then(() => {
        refreshData();
      })
      .catch((err) => {
        setLoading(false);
        notificationErroInternal(
          "Aconteceu um erro inesperado, por favor, tente mais tarde."
        );
      });
  }
  return (
    <div className="container-managerial">
      <PageToolbar style={{ padding: "10px" }}>
        <Button
          loading={syncLoading}
          style={{
            fontFamily: FONT,
            background: "#09ac9c",
          }}
          type="primary"
          icon={
            <RotateCw
              size={18}
              style={{ marginBottom: "-3px", marginRight: "7px" }}
            />
          }
          onClick={() => {
            updateEvo();
          }}
        >
          Sincronizar EVO
        </Button>
        <Button
          style={{
            fontFamily: FONT,
          }}
          type="primary"
          icon={
            <Plus
              size={18}
              style={{ marginBottom: "-3px", marginRight: "7px" }}
            />
          }
          onClick={updateList}
        >
          Abrir Treino
        </Button>
        <Badge count={trainingFinish.length} overflowCount={10}>
          <Button
            style={{
              fontFamily: FONT,
              background: "#fcad03",
            }}
            type="primary"
            onClick={showDrawerTrainingFinish}
          >
            Finalizados
          </Button>
        </Badge>
      </PageToolbar>
      <Row>
        <div style={{ fontFamily: FONT, fontSize: 12, marginBottom: 15 }}>
          Última atualização: {formatTime(lastUpdated)}{" "}
        </div>
      </Row>
      <Spin spinning={loading}>
        {data.length > 0 && (
          <Row gutter={16}>
            <CardTrainings usersTrainings={data} />
          </Row>
        )}
        {dataBoot.length > 0 && (
          <>
            <Divider />
            <Typography.Title
              level={5}
              style={{ margin: 0, textAlign: "center", color: "#979993" }}
            >
              Alunos em Iniciação
            </Typography.Title>
            <Divider />

            <Row gutter={16}>
              <CardTrainingsBoot usersTrainings={dataBoot} />
            </Row>
          </>
        )}
        {dataBoot.length == 0 && data.length == 0 && (
          <Row gutter={16}>
            <div style={{ textAlign: "center", width: "100%" }}>
              <ListEmptyState subTitle={"A sessão de treino está vazia"} />
            </div>
          </Row>
        )}
      </Spin>

      <DrawerApp
        open={openDetail}
        onClose={onCloseDetail}
        title={"Detalhe do Ciclo"}
        body={""}
        size={"large"}
        isOnlyView={true}
      />
      <DrawerApp
        open={openDetail}
        onClose={onCloseDetail}
        title={"Detalhe do Ciclo"}
        body={
          <PlanningExercises
            isOnlyView={true}
            exercises={
              userTrainer != null
                ? userTrainer.planningTrainings.map((item) => {
                    return {
                      ...item,
                      type: item.planningType,
                      cycle: item.cycleName?.replace(/\D/g, ""),
                      detail: detail,
                    };
                  })
                : []
            }
          />
        }
        size={"large"}
        isOnlyView={true}
      />

      <DrawerApp
        open={openDetailItem}
        onClose={onCloseDetailItem}
        title={"Detalhe do Exercicio"}
        body={
          <FormNewUserPlanningExercise
            onClose={onCloseDetailItem}
            user={userTrainer}
            exercise={exercise}
          />
        }
        size={"large"}
        isOnlyView={true}
      />
      <DrawerApp
        open={openTrainingFinish}
        onClose={onCloseFinishTraining}
        title={"Cíclos Finalizados"}
        body={<CardTrainingsFinish usersTrainings={trainingFinish} />}
        size={"large"}
        isOnlyView={true}
        width={drawerWidth(isMobile, 45)}
      />

      <DrawerApp
        open={openChart}
        onClose={onCloseChart}
        title={"Gráfico de Evolução"}
        body={<ManagerialChart onClose={onCloseChart} user={userTrainer} />}
        size={"large"}
        isOnlyView={true}
      />
      <DrawerApp
        open={openChartFinish}
        onClose={onCloseChartFinish}
        title={"Gráfico de Evolução"}
        body={
          <ManagerialChart onClose={onCloseChartFinish} user={userTrainer} />
        }
        size={"large"}
        isOnlyView={true}
      />
      <DrawerApp
        open={openReview.open}
        onClose={onCloseReview}
        title={"Nova Avaliação"}
        body={
          openReview.edit ? (
            <FormNewUserReview
              user={userTrainer}
              showSprints={false}
              editId={userTrainer.lastReview?.id}
              editRow={userTrainer?.lastReview}
              onClose={onCloseReview}
            />
          ) : (
            <FormNewUserReview
              user={userTrainer}
              showSprints={true}
              lastReview={userTrainer?.lastReview}
              onClose={onCloseReview}
            />
          )
        }
        size={"large"}
        isOnlyView={true}
      />

      <DrawerApp
        open={openPlaning}
        onClose={onClosePlaning}
        title={"Nova Planificação"}
        body={
          <FormNewUserPlanning onClose={onClosePlaning} user={userTrainer} />
        }
        size={"large"}
        isOnlyView={true}
      />
      <DrawerApp
        open={openDetailBoot}
        onClose={onCloseDetailBoot}
        title={"Ciclo de Treino"}
        body={<FormTrainningBoot />}
        width={drawerWidth(isMobile, 30)}
        isOnlyView={true}
      />

      <DrawerApp
        open={openProgress}
        onClose={onCloseProgress}
        title={"Progresso"}
        body={<TimelineBoot user={userTrainerBoot} />}
        size={"large"}
        isOnlyView={true}
        width={drawerWidth(isMobile, 50)}
        extra={
          <Button
            style={{
              fontFamily: FONT,
              background: "#14B8A6",
              color: "#ffffff",
            }}
            onClick={() => setOpenDetailBoot(true)}
          >
            Ciclo de Treino
          </Button>
        }
      />
      <DrawerApp
        open={openChangeTraining}
        onClose={onCloseChangeTraining}
        title={"Alterar Treino & Carga"}
        body={
          <ChangeBoot
            user={userTrainerBoot}
            onCloseDrawer={onCloseChangeTraining}
          />
        }
        size={"large"}
        isOnlyView={true}
        width={drawerWidth(isMobile, 50)}
      />
    </div>
  );
};

export default Managerial;
